export const loadStudyPreviewLanguage = async (messagesKey: string) => {
  return (await import(`@myvp/study-preview/src/i18n/languages/${messagesKey}`))
    .default
}
